import $ from 'jquery';

class Search {
    constructor (){

        // Opening the header search
        this.searchPopup = $('.site-header__open-search');
        this.searchMenu = $('.search-menu');


        // Search box elements
        this.resultsDivWrap = $('.search-box__results-wrap');
        this.resultsDiv = this.resultsDivWrap.find('.search-box__results');
        this.searchField = $('.search-box__input');
        
        
        this.events();
        this.previousValue;
        this.typingTimer;
    }

    // List of events
    events(){
        this.searchField.on("click", function(event) {
            event.stopPropagation();
            this.openOverlay();
        }.bind(this));
        $(document).on('keydown', this.keyPressDispatcher.bind(this));
        $(window).on('click', this.closeOverlay.bind(this));
        this.searchField.on('keyup', this.typingLogic.bind(this));
    }


    // Methods
    typingLogic(e) {
        const searchField = $(e.target);  // Get the specific search input that triggered the event
        // Only if the search input is being changed. No arrow keys
        if (this.previousValue != searchField.val()) {
            this.resultsDivWrap.addClass('loading');
            clearTimeout(this.typingTimer);
            if (searchField.val() && searchField.val().length > 3) {
                // Pass the specific searchField to getResults
                this.typingTimer = setTimeout(() => this.getResults(searchField), 500);
            } else {
                this.resultsDiv.html('');
                this.resultsDivWrap.removeClass('loading');
                this.resultsDivWrap.removeClass('has-value');
            }
        }

        // Update previousValue
        this.previousValue = searchField.val();
    }

    getResults(searchField) {
        /* Custom Wordpress Rest API */
        $.getJSON(wemake.root_url + '/wp-json/wemake/v1/search?term=' + searchField.val(), (results) => {
            if(this.hasAnyValue(results)){
                this.resultsDivWrap.addClass('has-value');
                this.resultsDiv.html('');
            }
            else{
                this.resultsDivWrap.removeClass('has-value');
                this.resultsDiv.html('Geen resultaten gevonden voor deze zoekopdracht.');
            }
    
            // Function to limit results to 4 and add custom "Bekijk alle..." link
            const limitResults = (items, customLink, linkText) => {
                let html = '';
                let limitedItems = items.slice(0, 4);
                limitedItems.forEach(item => {
                    html += `<li><a href="${item.permalink}" data-id="${item.id}">${item.title}</a></li>`;
                });
                // Check if there are more than 4 items, then add custom "Bekijk alle..." link
                if (items.length > 4 && linkText != '') {
                    html += `<li><a class="chevron" href="${customLink}">${linkText}</a></li>`;
                }
                return html;
            };
    
            // Products
            if (results.gemeenten.length){
                this.resultsDiv.append(`
                    ${results.gemeenten.map(item => `
                    <a href="${item.url}" class="search-box__results-item d-f f-j-s">
                        <div class="d-f fd-c gap-5">
                            <strong>Gemeente</strong>
                            <span class="t-c-s t-14">${item.title}</span>
                        </div>
                        <span class="t-13">${item.aantalRoutes} beschikbare routes</span>                        
                    </a>
                    `).join('')}
                `);
            }
    
            // Projects
            if (results.activiteiten.length){
                this.resultsDiv.append(`
                    ${results.activiteiten.map(item => `
                    <a href="${item.url}" class="search-box__results-item d-f f-j-s">
                        <div class="d-f fd-c gap-5">
                            <strong>${item.datum}</strong>
                            <span class="t-c-s t-14">${item.title}</span>
                        </div>
                        <span class="t-13">${item.category}</span>                        
                    </a>
                    `).join('')}
                `);
            }
    
            
            // General Info (Pages and Posts)
            if (results.routes.length){
                this.resultsDiv.append(`
                    ${results.routes.map(item => `
                    <a href="${item.url}" class="search-box__results-item d-f f-j-s">
                        <div class="d-f fd-c gap-5">
                            <span class="t-c-s t-14">${item.title}</span>
                        </div>                   
                    </a>
                    `).join('')}
                `);
            }
            
    
    
            // Attach click handler to the links
            this.resultsDivWrap.removeClass('loading');
        });        
    }

    keyPressDispatcher(e){
        if (e.keyCode == 83 && !this.isOverlayOpen && !$('input, textarea').is(':focus')){
            this.openOverlay();
        }

        if (e.keyCode == 27){
            this.closeOverlay();
        }
    }

    openOverlay(){
        this.resultsDivWrap.addClass('active');
        this.searchField.addClass('active');
        this.searchField.focus();
    }

    closeOverlay(){
        this.resultsDivWrap.removeClass('active');
        this.searchField.removeClass('active');
    }

    hasAnyValue(data) {
        for (let key in data) {
            if (Array.isArray(data[key]) && data[key].length > 0) {
                return true; 
            }
        }
        return false; 
    }

    popupSwitch(){
        if (this.searchPopup.hasClass('active')){
            this.searchPopup.removeClass('active');
            this.searchMenu.removeClass('active');
        }
        else{
            this.searchPopup.addClass('active');
            this.searchMenu.addClass('active');
        }
    }
}

export default Search